var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-icon",style:({width: this.size + 'px', height: this.size + 'px'}),attrs:{"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }